import TrendChart from '../../../common/components/trend-chart';
import { IconTrendingUp } from '../../../common/icons';
import { formatDateOnly } from '../../../core/utils/date';
import { fmtMoney, fmtPct } from '../../../core/utils/format';
import { useClientPortfolio } from '../contexts/portfolio';

import '../styles/investor-hero.css';

// TSS vite/03 — primera impresión del INVERSIONISTA: un gráfico "tipo trading"
// del valor de su participación en el tiempo (serie de la vaca PRINCIPAL —la que
// más creció— escalada por su %), seguido del KPI de su mejor rendimiento.
// La serie sale de economics.valorizacion.series (Q-309); el % escala la serie a
// "su dinero". Sin dato de crecimiento aún → estados honestos (no 0 inventado).

const sign = (n) => (n > 0 ? '+' : '');
const tone = (n) => (n == null || n === 0 ? 'flat' : n > 0 ? 'up' : 'down');

function Skeleton() {
    return (
        <div className="invhero invhero--loading">
            <div className="invhero__skeleton" />
            <div className="invhero__skeleton invhero__skeleton--kpi" />
        </div>
    );
}

export default function InvestorHero() {
    const { isLoading, principal } = useClientPortfolio();

    if (isLoading) return <Skeleton />;
    if (!principal) return null;

    const pctFrac = principal.percent != null ? principal.percent / 100 : 1;
    const stakeOf = (amount) => (amount == null ? null : amount * pctFrac);

    // Serie del valor de la participación (o del activo si no hay %).
    const points = principal.series.map((p) => ({ date: p.date, v: stakeOf(p.amount) }));
    const hasCurve = points.length >= 2;
    const current = points.length ? points[points.length - 1].v : principal.currentValue;
    const growth = principal.growthPct;
    const t = tone(growth);

    return (
        <section className="invhero">
            {/* Panel trading */}
            <div className="invhero__panel">
                <header className="invhero__head">
                    <div>
                        <span className="invhero__eyebrow">Tu inversión principal</span>
                        <h2 className="invhero__cow">{principal.name}</h2>
                    </div>
                    <div className="invhero__quote">
                        <span className="invhero__value">{fmtMoney(current)}</span>
                        {growth != null && (
                            <span className={`invhero__change invhero__change--${t}`}>
                                <span className="invhero__arrow" aria-hidden="true">{t === 'down' ? '↓' : '↑'}</span>
                                {sign(growth)}{fmtPct(growth)}
                            </span>
                        )}
                    </div>
                </header>

                {hasCurve ? (
                    <TrendChart
                        xLabels={points.map((p) => formatDateOnly(p.date))}
                        series={[{ key: 'stake', label: 'Valor de tu participación', variant: 'area', values: points.map((p) => p.v) }]}
                        format={fmtMoney}
                        height={220}
                        ariaLabel={`Valor de tu participación en ${principal.name} en el tiempo`}
                    />
                ) : (
                    <p className="invhero__nocurve">
                        Aún no hay suficientes valuaciones para trazar la curva. En cuanto se registre otro
                        avalúo verás aquí la evolución de tu inversión.
                    </p>
                )}
            </div>

            {/* KPI — tu mejor rendimiento */}
            <div className={`invhero__kpi invhero__kpi--${t}`}>
                <span className="invhero__kpi-icon"><IconTrendingUp /></span>
                <div className="invhero__kpi-body">
                    <span className="invhero__kpi-label">Tu vaca que más ha crecido</span>
                    <span className="invhero__kpi-name">{principal.name}</span>
                </div>
                <div className="invhero__kpi-nums">
                    <span className="invhero__kpi-pct">
                        {growth != null ? `${sign(growth)}${fmtPct(growth)}` : '—'}
                    </span>
                    {principal.stakeAbs != null && (
                        <span className="invhero__kpi-abs">{sign(principal.stakeAbs)}{fmtMoney(principal.stakeAbs)}</span>
                    )}
                </div>
            </div>
        </section>
    );
}
